import { createGlobalStyle } from 'styled-components';

import { device } from '../utils';

//Montserrat
export default createGlobalStyle`
  :root {
    --header-height: 70px;
    --scrollbar-width: 15px;
    --container-padding-inline: 20px;

    @media ${device.laptop} {
      --container-padding-inline: 40px;
    }
  }

  body {
    font-family: 'Roboto', Helvetica, Arial, sans-serif;
    margin: 0;
  }

  html, body {
    -moz-font-smoothing: antialiased;
    -o-font-smoothing: antialiased;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
    font-size: 16px;

    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  body {
    --dm-background-color: 255, 255, 255;
    --dm-color: #111111;
    --tuto-polaroid-background-color: 0, 0, 0;

    background-color: rgb(var(--dm-background-color));
    &, a {
      color: var(--dm-color);
    }
  }

  body[darkmode="true"] {
    --dm-background-color: 0, 0, 0;
    --tuto-polaroid-background-color: 50, 50, 50; 
    --dm-color: #FFF;
    --swiper-pagination-bullet-inactive-color: #FFF;
    --swiper-pagination-bullet-inactive-opacity: .6;
  }

  a {
    text-decoration: none;
    outline: none;
  }

  * {
    -webkit-tap-highlight-color: rgba(0,0,0,0)!important;
  }

  .gatsby-image-wrapper img {
    /* transition: opacity .5s ease 0s!important; */
    font-size: 0;
  }

  button {
    cursor: pointer;
    outline: none;
  }

  button.clear {
    background: none;
    border: 0;
    appearance: none;
    -webkit-appearence: none;
  }

  .button {
    display: block;
    font-weight: 900;
    color: #000;
    text-align: center;
    padding: 10px 20px;
    margin: 15px 0;
  
    &.dark {
      background-color: #000;
      color: #FFF;
    }
  }

  h1, h2, h3, h4 {
    font-family: 'Montserrat';
  }

  b, strong {
    font-weight: 500;
  }

  .bigtitle {
    font-family: 'Montserrat';
    font-size: 20px;
    /* letter-spacing: 0.38px; */
    /* line-height: 0.9em; */
    margin: 10px 0;
    font-weight: 900;
    text-transform: uppercase;

    @media ${device.laptop} {
      font-size: 24px;
    }

    &.white {
      color: #FFF;
    }
  }

  .redtitle {
    font-family: 'Montserrat';
    font-size: 24px;
    color: #E0261D;
    line-height: 1em;
    margin: 20px 0 10px;
    text-transform: uppercase;
    font-weight: lighter;
  }

  .product-image {
    img {
      /* filter: saturate(1.01) contrast(1.01) brightness(1.01); */
    }
  }

  .product-grid {
    display: grid;
    grid-gap: 20px 20px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    justify-content: center;
    box-sizing: border-box;

    @media ${device.laptop} {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    @media ${device.laptopM} {
      grid-gap: 40px 60px;
    }

    &.three {
      @media ${device.laptop} {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  }

  p {
    line-height: 1.3em;
  }

  #gatsby-noscript {
    background: #000;
    width: 100%;
    display: block;
    padding: 10px;
    color: #FFF;
    text-align: center;
    font-weight: bold;
  }


  .mobile-only {
    @media ${device.tablet} {
      display: none!important;
    }
  }

  .h-mobile {
    @media ${device.tabletDown} {
      display: none!important;
    }
  }

  .h-tablet {
    @media ${device.laptopDown} and ${device.tablet} {
      display: none!important;
    }
  }

  .h-laptop {
    @media (min-width: 1025px) {
      display: none!important;
    }
  }

  .container {
    max-width: 1440px;
    margin: 0 auto;
    padding: 0 var(--container-padding-inline);
    box-sizing: border-box;
  }

  .bbox {
    display: inline-block;
    background: #000;
    padding: 7px;
    transform: skew(-15deg);

    &.title {
      padding: 10px 15px 5px 15px;
    }

    & > * {
      display: inline-block;
      transform: skew(15deg);
      color: #FFF;
      font-weight: 900;
      text-transform: uppercase;
    }
  }

  .menu-link {
    position: relative;
    font-weight: bold;
    text-transform: uppercase;
    padding: 5px 0;

    &:before, &:after {
      content: "";
      position: absolute;
      left: 0px;
      z-index: 9;
      height: 1px;
      width: 100%;
      top: 0px;
      background-color: #000;
      transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0s;
      transform: scaleX(0);
      transform-origin: left;
    }

    &:after {
      top: auto;
      bottom: 0px;
      transform-origin: right;
    }

    &:hover, &.hover {
      &[href] {
        &:after, &:before {
          transform: scaleX(1) scaleY(1);
        }
      }
    }

    &.white {
      color: #FFF;
      &:before, &:after {
        background-color: #FFF;
      }
    }
  }

  .simple-link {
    position: relative;
    font-size: 14px;
    font-weight: 500;

    @media ${device.laptop} {
      font-size: 16px;
    }

    &:after {
      content: '>';
      display: inline-block;
      vertical-align: middle;
      font-weight: normal;
      margin-left: 3px;
      transform: scaleX(0.7) scaleY(1.1);
      transition: transform 300ms;
    }

    &:before {
      content: "";
      position: absolute;
      left: 0px;
      z-index: 9;
      height: 1px;
      width: 100%;
      bottom: -2px;
      background-color: #FFF;
      transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0s;
      transform: scaleX(0);
      transform-origin: left;
    }

    &.noicon {
      &:after {
        display: none;
      }
    }

    &.red {
      color: #c80f05;

      &:before {
        background-color: rgb(224, 38, 29);
      }
    }

    &.white {
      color: #FFF;
    }

    &.black {
      color: #000;

      &:before {
        background-color: #000;
      }
    }

    &.block {
      border-radius: 30px;
      background-color: #c80f05;
      padding: 7px 20px;
      transition: background-color 300ms;

      &:before {
        display: none;
      }

      &:hover, &.hover {
        background-color: #AF0D04;
      }
    }

    &:hover, &.hover {
      &:after {
        transform: scaleX(0.7) scaleY(1.1) translateX(3px);
      }

      &:before {
        transform: scaleX(1);
      }
    }
  }

  .axeptio_mount {
    .ax-discardButton {
      font-size: 10px;
      padding-top: 3px;
    }

    .axeptio_widget_wrapper {
      .ax-discardButton + div {
        img {
          margin-left: 20px;
        }
        span {
          font-weight: 900;
          line-height: 1.2em;
        }

        span, img {
          margin-top: 5px;
        }
      }
    }
  }

`;
